import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (detail == null) setError("Something went wrong. Please try again.");
      else if (typeof detail === "string") setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(e => e?.msg || JSON.stringify(e)).join(" "));
      else setError(String(detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md p-8 bg-white border border-gray-200">
        <div className="text-center mb-8">
          <div className="w-12 h-12 bg-navy-900 rounded-sm flex items-center justify-center mx-auto mb-4">
            <span className="text-white font-serif text-xl font-semibold">C</span>
          </div>
          <h1 className="font-serif text-2xl text-navy-900">Admin Portal</h1>
          <p className="text-gray-500 font-sans text-sm mt-1">Sign in to manage your website</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <Label htmlFor="login-email" className="text-gray-700 font-sans text-sm font-medium mb-2 block">Email</Label>
            <Input
              id="login-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="border-gray-200 rounded-sm h-11 font-sans"
              placeholder="admin@capstone.com"
            />
          </div>
          <div>
            <Label htmlFor="login-password" className="text-gray-700 font-sans text-sm font-medium mb-2 block">Password</Label>
            <Input
              id="login-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="border-gray-200 rounded-sm h-11 font-sans"
              placeholder="Enter password"
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-red-500 font-sans text-sm">{error}</p>}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full bg-navy-900 text-white py-3 rounded-sm font-sans text-sm font-medium hover:bg-navy-800 transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
